import {createFileRoute} from '@tanstack/react-router';
import {AuthVerifyPage} from '@/features/auth';
import {authSignedGuard, can} from '@/libs/router';

interface AuthVerifySearch {
  email?: string;
  code?: string;
  staffId?: string;
}

export const Route = createFileRoute('/_auth/auth/verify')({
  beforeLoad: can([authSignedGuard]),
  component: () => <AuthVerifyPage />,
  validateSearch: (search: AuthVerifySearch) => {
    return search;
  },
});
